// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2WvOG","center":"Loader_center__3TI5z","Loader1":"Loader_Loader1__2Z4oY","Loader2":"Loader_Loader2__2UCHy","Loader3":"Loader_Loader3__1AVMp"};